import { ref } from 'vue'
export default () => {
  const additionSort: any = ref([])
  const sortAdd = (addition: any, select: any) => {
    if (select) {
      if (!additionSort.value.find((i: any) => i.additionId === addition.additionId)) {
        // 新增时把辅料信息删除
        additionSort.value.unshift({
          ...addition,
          ingredientsSku: ''
        })
        if (addition.ingredientStatus) {
          // 选择的附加项需要辅料辅料时滚动到底部
          scrollView()
        }
      } else {
        // 水洗标，抽检类2次弹窗 选择附加项时需要把选中附加项的信息替换一遍
        additionSort.value = additionSort.value.map((i:any) => {
          return i.additionId === addition.additionId ? {
            ...i,
            ...addition
          } : i
        })
      }
    } else {
      additionSort.value = additionSort.value.filter((i: any) => i.additionId !== addition.additionId)
    }
  }

  const scrollView = (scrollTop?: number) => {
    const ele = document.querySelector('.el-drawer__body')
    setTimeout(() => {
      ele && (ele.scrollTop = scrollTop ?? 100000)
    }, 200)
  }
  return {
    additionSort,
    sortAdd,
    scrollView
  }
}
